import { createBrowserRouter } from 'react-router-dom';

import { DashboardLayout } from './components/DashboardLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { RequireRestaurant } from './components/RequireRestaurant';
import { RequireCap } from './components/RequireCap';
import { MarketingPage } from './pages/MarketingPage';
import { PartnersPage } from './pages/PartnersPage';
import { GuidePage } from './pages/GuidePage';
import { LoginPage } from './pages/LoginPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { DashboardPage } from './pages/DashboardPage';
import { MenuPage } from './pages/MenuPage';
import { TablesPage } from './pages/TablesPage';
import { TeamPage } from './pages/TeamPage';
import { FloorPage } from './pages/FloorPage';
import { KitchenPage } from './pages/KitchenPage';
import { BarPage } from './pages/BarPage';
import { DinerPage } from './pages/DinerPage';
import { GarcomPage } from './pages/GarcomPage';
import { QueuePage } from './pages/QueuePage';
import { WaitlistPage } from './pages/WaitlistPage';
import { LoyaltyPage } from './pages/LoyaltyPage';
import { SessionsPage } from './pages/SessionsPage';
import { CrmPage } from './pages/CrmPage';
import { SettingsPage } from './pages/SettingsPage';
import { AwardPage } from './pages/AwardPage';
import { ConsultantPage } from './pages/ConsultantPage';
import { BillingPage } from './pages/BillingPage';
import { LegalPage } from './pages/LegalPage';
import { MasterPage } from './pages/MasterPage';
import { PublicSitePage } from './pages/PublicSitePage';
import { PublicRestaurantPage } from './pages/PublicRestaurantPage';
import { PublicCityPage } from './pages/PublicCityPage';

export const router = createBrowserRouter([
  { path: '/', element: <MarketingPage lang="pt-BR" /> },
  { path: '/en', element: <MarketingPage lang="en" /> },
  { path: '/es', element: <MarketingPage lang="es" /> },
  { path: '/fr', element: <MarketingPage lang="fr" /> },
  { path: '/sistema-para-restaurantes', element: <GuidePage lang="pt-BR" /> },
  { path: '/en/restaurant-management-system', element: <GuidePage lang="en" /> },
  { path: '/es/sistema-para-restaurantes', element: <GuidePage lang="es" /> },
  { path: '/fr/logiciel-pour-restaurants', element: <GuidePage lang="fr" /> },
  { path: '/parceiros', element: <PartnersPage lang="pt-BR" /> },
  { path: '/en/partners', element: <PartnersPage lang="en" /> },
  { path: '/es/socios', element: <PartnersPage lang="es" /> },
  { path: '/fr/partenaires', element: <PartnersPage lang="fr" /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/t/:qrToken', element: <DinerPage /> },
  { path: '/garcom/:token', element: <GarcomPage /> },
  { path: '/fila/:slug', element: <QueuePage /> },
  { path: '/termos', element: <LegalPage kind="terms" /> },
  { path: '/privacidade', element: <LegalPage kind="privacy" /> },
  {
    path: '/onboarding',
    element: (
      <ProtectedRoute>
        <OnboardingPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/app',
    element: (
      <ProtectedRoute>
        <RequireRestaurant>
          <DashboardLayout />
        </RequireRestaurant>
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'menu', element: <RequireCap cap="admin"><MenuPage /></RequireCap> },
      { path: 'tables', element: <RequireCap cap="admin"><TablesPage /></RequireCap> },
      { path: 'floor', element: <RequireCap cap="ops"><FloorPage /></RequireCap> },
      { path: 'kitchen', element: <RequireCap cap="kitchen"><KitchenPage /></RequireCap> },
      { path: 'bar', element: <RequireCap cap="ops"><BarPage /></RequireCap> },
      { path: 'sessions', element: <RequireCap cap="ops"><SessionsPage /></RequireCap> },
      { path: 'waitlist', element: <RequireCap cap="queue"><WaitlistPage /></RequireCap> },
      { path: 'loyalty', element: <RequireCap cap="admin"><LoyaltyPage /></RequireCap> },
      { path: 'crm', element: <RequireCap cap="admin"><CrmPage /></RequireCap> },
      { path: 'award', element: <RequireCap cap="admin"><AwardPage /></RequireCap> },
      { path: 'consultant', element: <RequireCap cap="admin"><ConsultantPage /></RequireCap> },
      { path: 'billing', element: <RequireCap cap="finance"><BillingPage /></RequireCap> },
      { path: 'settings', element: <RequireCap cap="admin"><SettingsPage /></RequireCap> },
      { path: 'team', element: <RequireCap cap="admin"><TeamPage /></RequireCap> },
      { path: 'public', element: <RequireCap cap="admin"><PublicSitePage /></RequireCap> },
      { path: 'master', element: <RequireCap cap="master"><MasterPage view="panel" /></RequireCap> },
      { path: 'master/restaurantes', element: <RequireCap cap="master"><MasterPage view="restaurants" /></RequireCap> },
      { path: 'master/premio', element: <RequireCap cap="master"><MasterPage view="award" /></RequireCap> },
      { path: 'master/financeiro', element: <RequireCap cap="master"><MasterPage view="finance" /></RequireCap> },
      { path: 'master/leads', element: <RequireCap cap="master"><MasterPage view="leads" /></RequireCap> }
    ]
  },
  // Diretório público (geo) — colocado por último; rotas específicas têm prioridade
  { path: '/:country/:state/:city', element: <PublicCityPage /> },
  { path: '/:country/:state/:city/:slug', element: <PublicRestaurantPage /> }
]);
